/**
 * Some locales, like Japanese, reverse the ordering of the people names.
 * Return whether the provided string is such a locale.
 */
export const hasReversedNames = (lcLocale: string) => lcLocale === 'ja-jp';

/**
 * Whether the locale (expected to be lower-cased) requires (name) pronunciation fields.
 */
export const hasPronunciationFields = (lcLocale: string) => lcLocale === 'ja-jp';
